import { render, staticRenderFns } from "./NavMobileProductCategories.vue?vue&type=template&id=c635a038&scoped=true"
import script from "./NavMobileProductCategories.vue?vue&type=script&lang=js"
export * from "./NavMobileProductCategories.vue?vue&type=script&lang=js"
import style0 from "./NavMobileProductCategories.vue?vue&type=style&index=0&id=c635a038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c635a038",
  null
  
)

export default component.exports